/**
 * postMessage an das Eltern-Fenster (iFrame-Integration) mit Fehlerbehandlung.
 *
 * Die App läuft als iFrame in Kundenwebsites eingebettet. window.parent.postMessage
 * kann dort werfen (z.B. Cross-Origin-Restriktionen, Sandbox-Attribute) oder ins
 * Leere laufen — ein Fehler dabei darf den Auth-/Buchungs-Flow nicht crashen.
 */
export function postMessageToParent(message: unknown, targetOrigin: string = "*"): void {
    try {
        window.parent.postMessage(message, targetOrigin)
    } catch (error) {
        console.warn("[postMessage] Nachricht an das Eltern-Fenster fehlgeschlagen:", error)
    }
}
